import { gql } from 'apollo-boost';

const photoPricesQuery = gql`
  query PhotoPricesQuery {
    photoPricesCollection {
      items {
        number
        photo {
          url
          title
          description
        }
      }
    }
  }
`;

export default photoPricesQuery;